import { ROUTE_KEYS } from 'legacyfrontend/constants';
import { createSelector } from 'reselect';

const getApplicationState = (state) => state.applicationState;
const getTemplateData = (state) => state.applicationState?.templateData;
const getColors = (state) => state.applicationState?.templateData?.colors;
const getGeo = (state) => state.applicationState?.geo;
const getNavigation = (state) => state.applicationState?.navigation;
const getFooter = (state) => state.applicationState?.templateData?.footer;
const getCities = (state) => state.applicationState?.geo?.cities;
const getLocalities = (state) => state.applicationState?.geo?.localities;
const getPrincipalOffice = (state) => state?.applicationState?.templateData?.principalOffice;

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

export const selectApplicationState = createSelector(
  [getApplicationState],
  (appState) => appState || EMPTY_OBJECT
);

export const selectGeoDataIsReady = createSelector(
  [getCities, getLocalities],
  (cities, localities) => cities?.isReady && localities?.isReady
);

export const selectCities = createSelector([getCities], (cities) => cities?.data || EMPTY_ARRAY);

export const selectLocalities = createSelector(
  [getLocalities],
  (localities) => localities?.data || EMPTY_ARRAY
);

export const selectColors = createSelector([getColors], (colors) => {
  if (!colors || colors.length === 0) return null;
  try {
    return JSON.parse(colors[0].valor);
  } catch (error) {
    console.warn('Error parsing colors:', error);
    return null;
  }
});

export const selectHeader = createSelector(
  [getTemplateData],
  (templateData) => templateData?.header || EMPTY_OBJECT
);

export const selectNavigation = createSelector(
  [getNavigation],
  (navigation) => navigation || EMPTY_OBJECT
);

export const selectFooter = createSelector([getFooter], (footer) => footer || EMPTY_OBJECT);

export const selectFooterDetalle = createSelector(
  [getFooter],
  (footer) => footer?.detalle || EMPTY_ARRAY
);

export const selectTemplateData = createSelector(
  [getTemplateData],
  (templateData) => templateData || EMPTY_OBJECT
);

export const selectPrincipalOffice = createSelector(
  [getPrincipalOffice],
  (principalOffice) => principalOffice || EMPTY_OBJECT
);

export const selectTemplateImage = createSelector(
  [getApplicationState],
  (appState) => appState?.templateImage || ''
);

export const selectHeaderImagen = createSelector(
  [getTemplateData],
  (templateData) => templateData?.headerImagen?.[0]?.valor || null
);

export const selectBannersState = createSelector(
  [(state) => state?.bannersState],
  (bannersState) => bannersState || EMPTY_OBJECT
);

export const selectSectionState = createSelector(
  [(state) => state?.sectionState],
  (sectionState) => sectionState || EMPTY_OBJECT
);

export const selectToken = createSelector(
  [getApplicationState],
  (appState) => appState?.token || ''
);

export const selectPaisId = createSelector(
  [selectApplicationState],
  (appState) => appState?.paisId || 1
);

export const selectGeoData = createSelector([getGeo], (geo) => geo || null);

export const selectGeoLocalities = createSelector([getGeo], (geo) => geo?.localities || null);

export const selectGeoCities = createSelector([getGeo], (geo) => geo?.cities || null);

export const selectApplicationId = createSelector(
  [getApplicationState],
  (appState) => appState?.applicationId || 0
);

export const selectPackagesDetails = createSelector(
  [(state) => state?.packages?.details?.data],
  (details) => details || EMPTY_OBJECT
);

export const selectTemplateId = createSelector(
  [selectApplicationState],
  (appState) => appState?.paisId || 1
);

export const selectApplicationInfo = createSelector([selectApplicationState], (appState) => {
  if (!appState) return EMPTY_OBJECT;

  return {
    applicationId: appState.applicationId || '',
    nombre: appState.nombre || '',
    paisId: appState.paisId || 1,
    templateData: appState.templateData || EMPTY_OBJECT,
    token: appState.token || '',
    currency: appState.currency || EMPTY_OBJECT,
  };
});

export const selectIsPackageSearcherEnabled = createSelector(
  [selectTemplateData],
  (templateData) => templateData?.headerPaquete?.length > 0
);

export const selectIsFlightSearcherEnabled = createSelector(
  [selectTemplateData],
  (templateData) => templateData?.headerVuelos?.length > 0
);

export const selectFirstActiveRoute = createSelector(
  [selectIsPackageSearcherEnabled, selectIsFlightSearcherEnabled],
  (isPackageEnabled, isFlightEnabled) => {
    if (isPackageEnabled) {
      return ROUTE_KEYS.BUSCAR_X_PAQUETES;
    }
    if (isFlightEnabled) {
      return ROUTE_KEYS.BUSCAR_X_VUELOS;
    }
    return ROUTE_KEYS.HOME;
  }
);

export const selectHasActiveSearchers = createSelector(
  [selectIsPackageSearcherEnabled, selectIsFlightSearcherEnabled],
  (isPackageEnabled, isFlightEnabled) => isPackageEnabled || isFlightEnabled
);

export default {
  geoDataIsReady: selectGeoDataIsReady,
  cities: selectCities,
  localities: selectLocalities,
};
